// apiUrls.js
export const API_URLS = {
  COPY_STANDARD_FORM: (id) => `/api/client/form-template/copy/${id}`,
  COPY_DYNAMIC_FORM: (id) => `/api/client/custom-form/copy/${id}`,
  SUBMIT_QUESTION: (formId) => `/api/client/custom-form/edit/${formId}`,
  ALL_QUESTIONSPERSECTION: (limit) =>
    `/api/client/questions/sections?pageSize=${limit}`,
  ALL_SECTIONS: (currentPage, limit, searchTerm = "") =>
    `/api/client/questions/sections?pageNo=${currentPage}&pageSize=${limit}&search=${encodeURIComponent(
      searchTerm,
    )}`,

  SUBSECTION_BY_ID: (subsectionId, currentPage, limit, searchTerm = "") =>
    `/api/client/questions/subsection/${subsectionId}?pageNo=${currentPage}&pageSize=${limit}&search=${encodeURIComponent(
      searchTerm,
    )}`,

  QUESTIONS_BY_SUBSECTION: (subSectionId, searchTerm = "") =>
    `/api/client/questions/getBySubsection/${subSectionId}?search=${encodeURIComponent(
      searchTerm,
    )}`,
  ALL_QUESTIONSPERSECTION: (limit) =>
    `/api/client/questions/sections?pageSize=${limit}`,
  // SUBMIT_QUESTION: formId => `/api/client/form-template/questions/${formId}`,

  CUSTOMFORM_SECTIONS: (formId) => `/api/client/custom-form/sections/${formId}`, // Get sections of a custom form
  CUSTOMFORM_SUBSECTIONS: (formId, sectionId) =>
    `/api/client/custom-form/subsections?formId=${formId}&sectionId=${sectionId}`, // Get subsections of a custom form
  CUSTOMFORM_QUESTIONS: (formId, sectionId, subsectionId) =>
    `/api/client/custom-form/questions?formId=${formId}&sectionId=${sectionId}&subsectionId=${subsectionId}`, // Get questions of a custom form

  CREATE_CUSTOMFORM: "/api/client/custom-form/create",
  QUESTIONS_GETALL: "/api/admin/questions/all", // Example: Get all questions
  QUESTIONS_SECTION: (id) => `/api/admin/questions/section/${id}`, // Dynamic: Get section by ID
  QUESTIONS_SUBSECTION: (id) => `/api/admin/questions/subsection/${id}`, // Dynamic: Get subsections by ID
  LOGIN_CLIENT: "/api/auth/client/login", // API endpoint for client login
  SIGN_UP_CLIENT: "/api/auth/client/signup", // API endpoint for client signup
  OTP_EMAIL: "/api/auth/client/verification-mail", //// API endpoint for client mail otp,
  FORGOT_EMPLOYEE_PASSWORD: "/api/auth/emp/reset-password",
  RESET_EMPLOYEE_PASSWORD: "/api/auth/emp/change-password-with-token",
  EMP_CHANGE_PASSWORD_WITH_TOKEN: "/api/auth/emp/change-password-with-token",
  FORGOT_PASSWORD: "/api/auth/client/reset-password", ////API end point for reset password
  CHANGE_PASSWORD_WITH_TOKEN: "/api/auth/client/change-password-with-token",
  VALIDATE_SWITCH_TOKEN: "/api/auth/client/validate-switch-token", // API endpoint for validate Switch Token
  CREATE_SWITCH_REQUEST: "/api/auth/client/create-switch-request", // API endpoint for create-switch-request
  LOGIN_EMPLOYEE: "/api/auth/emp/login", // API endpoint for employee login
  YOUR_QUESTION: "/api/client/custom-form/getAll", //API endpoint to get Question for Your Question Route
  GET_ALL_PROJECT_TYPES: (pageSize) =>
    `/api/client/project/type?pageSize=${pageSize}`,

  GET_PROJECTS: (page, pageSize, createdAt, search, filterData) =>
    `/api/client/project/get?limit=${pageSize}&skip=${
      (page - 1) * pageSize
    }&sort=${createdAt}&search=${search}&filter=${encodeURIComponent(
      JSON.stringify(filterData || {}),
    )}`, //API to get all projects
  // /Reports url

  // GET_ALL_REPORTS:"/api/client/report/allReport",
  GET_ALL_REPORTS: (pageNo, pageSize, search = "", projectId, clientId) =>
    `/api/client/report/allReport?page=${pageNo}&limit=${pageSize}&search=${search}&project_id=${projectId}&client_id=${clientId}`,

  GET_ALL_REQUEST_REPORTS: (pageSize, pageNo, projectId, clientId) =>
    `/api/client/report/getAllReport?page=${pageNo}&limit=${pageSize}&project_id=${projectId}&client_id=${clientId}`,

  VIEW_ALL_REPORTS: (id) => `/api/client/report/getCustomerReport/${id}`,
  CREATE_REQUEST_REPORTS: "/api/client/report/create-request",
  // /Reports url
  GET_ROLE: "/api/client/project/get-role",
  GET_STANDARDFORM: (
    projectId,
    searchTerm = "",
    pageNo,
    pageSize,
    skipValue,
  ) => {
    let url = `/api/client/project/get/standard-form/${projectId}?search=${encodeURIComponent(searchTerm)}`;
    if (pageNo !== undefined && pageNo !== null) url += `&pageNo=${pageNo}`;
    if (pageSize !== undefined && pageSize !== null)
      url += `&limit=${pageSize}`;
    if (skipValue !== undefined && skipValue !== null)
      url += `&skip=${skipValue}`;
    return url;
  },

  GET_SECTION: (formId) => `/api/client/project/get/section/${formId}`,
  GET_SECTION_BY_FORMID: (formId) =>
    `/api/client/project/get/section/${formId}`,
  GET_PROJECT_CUSTOMFORM: (projectId) =>
    `/api/client/project/get/custom-form/${projectId}`,
  GET_ALL_CUSTOM_FORM: "/api/user/custom-form/getAll",
  GET_CUSTOM_FORM_BY_PROJECTID: (projectId) =>
    `/api/client/project/get/custom-form/${projectId}`,
  GET_DYNAMIC_FORM_BY_CLIENTID: (clientId) =>
    `/api/admin/custom-template/user-templates/${clientId}`,
  USERS_GETALL: (pageSize, pageNo) =>
    `/api/emp/auth/get?pageSize=${pageSize}&pageNo=${pageNo}`, // Dynamic: Get all users with pagination

  UPDATE_USER: (id) => `/api/client/employee/update/${id}`,

  UPDATE_EMPLOYEE: (id) => `/api/client/employee/update/${id}`,
  //PERMISiON FORM
  SETUP_FORM: "/api/client/setup/create-form",
  GET_LICENSE_COST: "/api/client/licenseCost/list",
  CREATE_USER: "/api/client/employee/add-employee",
  CREATE_PROJECT: "/api/client/project/create", //post api for creating project
  ADD_NEW_DYNAMIC_FORM: (projectId) =>
    `/api/client/project/add-dynamic-form/${projectId}`,

  GET_ALL_USER_BY_CLIENT_ID: (
    clientId,
    page,
    limit,
    searchTerm,
    filterData = {},
  ) => {
    let url = `/api/client/project/getUser?client_id=${clientId}&pageNo=${page}&limit=${limit}&skip=${
      (page - 1) * limit
    }`;
    if (searchTerm && searchTerm.trim() !== "") {
      url += `&search=${encodeURIComponent(searchTerm)}`;
    }
    if (filterData && filterData.status) {
      url += `&status=${encodeURIComponent(filterData.status)}`;
    }
    if (filterData && filterData.role) {
      url += `&role=${encodeURIComponent(filterData.role)}`;
    }
    return url;
  },
  GET_PROJECTS_BY_USER_ID: (userId) =>
    `/api/client/project/user-detail?limit=10&skip=0&sort=-createdAt&user_id=${userId}`,
  UPDATE_HIERARCHY_STATUS: (formAllotmentId, employeeId) =>
    `/api/client/form-allotment-hierarchy/${formAllotmentId}/employee/${employeeId}/status`,
  EMP_UPDATE_HIERARCHY_STATUS: (formAllotmentId, employeeId) =>
    `/api/emp/hierarchy/${formAllotmentId}/employee/${employeeId}/status`,

  //http://localhost:8081/api/client/project/getUser?client_id=688de363103ad3caa0073cd9

  // GET_STANDARDFORM_ASSIGNED_USER: (projectId, templateId) =>
  //   `/api/client/standard-assign-form-allotment/get?projectId=${projectId}&templateId=${templateId}`,
  CREATE_DYNAMIC_ASSIGN_FORM: "/api/client/custom-assign-form-allotment/create",
  CREATE_STANDARD_ASSIGN_FORM:
    "/api/client/standard-assign-form-allotment/create",

  CREATE_TICKET: "/api/client/support/create-ticket",

  ALL_TICKETS: (pageNo, pageSize, status, searchTerm = "") =>
    `/api/client/support/all-ticket?pageNo=${pageNo}&pageSize=${pageSize}&status=${status}&search=${encodeURIComponent(
      searchTerm,
    )}`,

  GET_FILTERED_PROJECTS: (limit, skip, sort, filterData) =>
    `/api/client/project/get?limit=${limit}&skip=${skip}&sort=${sort}&filter=${encodeURIComponent(
      JSON.stringify(filterData),
    )}`,

  TICKET_DETAILS: (ticket_id) => `/api/client/support/ticket/${ticket_id}`,
  TICKET_REPLY: "/api/client/support/reply",

  // GET_SECTIONS: (page, pageSize, createdAt) =>
  //   `/api/client/custom-section/get?limit=${pageSize}&skip=${
  //     (page - 1) * pageSize
  //   }&sort=${createdAt}`,

  GET_SECTIONS: (page, pageSize, createdAt, search = "") =>
    `/api/client/custom-section/get?limit=${pageSize}&skip=${(page - 1) * pageSize}&sort=${createdAt}&search=${encodeURIComponent(search)}`,

  CREATE_SECTIONS: "/api/client/custom-section/create",
  UPDATE_SECTION: (sectionId) =>
    `/api/client/custom-section/update/${sectionId}&`,

  GET_SUBSECTIONS: (sectionId, search = "") =>
    `/api/client/custom-subsection/getByCustomSection/${sectionId}?search=${encodeURIComponent(search)}`,

  CREATE_SUBSECTIONS: "/api/client/custom-subsection/create",
  UPDATE_SUBSECTION: (subSectionId) =>
    `/api/client/custom-subsection/update/${subSectionId}`,
  SEND_QUERY: (ticketId) =>
    `/api/client/support/new-query?ticketId=${ticketId}`,
  PROFILE_DETAILS: "/api/client/auth/profile",
  UPDATE_CLIENT_PROFILE: "/api/client/auth/profile",
  UPDATE_ORGANIZATION_CLIENT_PROFILE: "/api/client/auth/organization/profile",
  DELETE_CLIENT_PROFILE_IMAGE: (type) =>
    `/api/client/auth/profile/image/${type}`,
  CLIENT_SEND_BILLING_OTP: "/api/client/auth/otp/send",
  CLIENT_VERIFY_BILLING_OTP: "/api/client/auth/otp/verify",
  ORG_MODE: "/api/client/auth/org-mode",
  CREATE_DEPARTMENT: "/api/client/department",
  // emp apis
  GET_ALL_STANDARD_DYNAMIC_FORMS: (
    userId,
    limit = 10,
    skip = 0,
    sort = "-createdAt",
    search = "",
    status = "",
  ) =>
    `/api/emp/form/getall-standard-dynamicform?limit=${limit}&skip=${skip}&sort=${sort}&user_id=${userId}&search=${encodeURIComponent(
      search,
    )}${status ? `&status=${encodeURIComponent(status)}` : ""}`,
  EMP_DETAILS: (id) => `/api/emp/emp-user/get/${id}`,
  // emp apis
  GET_EMP_USER_DETAILS: (userId, limit = 10, skip = 0, sort = "-createdAt") =>
    `/api/emp/emp-user/user-details?limit=${limit}&skip=${skip}&sort=${sort}&user_id=${userId}`,
  GET_EMP_PROFILE: "/api/emp/auth/profile",
  UPDATE_EMP_PROFILE: "/api/emp/auth/profile",
  DELETE_EMP_PROFILE_IMAGE: (type) => `/api/emp/auth/profile/image/${type}`,

  GET_KYC_DETAILS: "/api/client/auth/kyc-details",
  GET_SECTION_SUBSECTION: (formId) =>
    `/api/client/form/get-section-subsection/${formId}`,
  GET_STANDARDFORMS: (client_id, currentPage, limit, searchTerm) =>
    `/api/client/form/standard-form?page=${currentPage}&pageSize=${limit}&search=${searchTerm}&client_id=${client_id}`,
  GET_STANDARD_FORM_BY_ID: (formId) => `/api/client/form/getbyId/${formId}`, // API to get standard form by ID
  QUESTIONS_SUBSECTION_BY_ID: (subsectionId) =>
    `/api/client/questions/subsection/${subsectionId}`,
  SECTION_STATUS_CHANGE: (sectionId) =>
    `/api/client/custom-section/update-status/${sectionId}`,
  CREATE_QUESTION: `/api/client/customQuestions/create`,
  GET_PROJECT_BY_ID: (projectId) => `/api/client/project/get/${projectId}`,

  // GET_CUSTOM_QUESTION: (page, filterData,searchTerm = "") =>
  //   `/api/client/customQuestions/all?page=${page}&search=${searchTerm}&filter=${encodeURIComponent(
  //     JSON.stringify(filterData || {}),
  //   )}`, //API to get all question

  GET_CUSTOM_QUESTION: (page, filterData, search = "") =>
    `/api/client/customQuestions/all?page=${page}&search=${encodeURIComponent(search)}`,

  // GET_CLIENT_EMP_ACCESS_LIST: (pageNo, pageSize) =>
  //   `/api/admin/client/emp-access/list?pageNo=${pageNo}&pageSize=${pageSize}`,

  GET_CLIENT_EMP_ACCESS_LIST: (pageNo, pageSize, searchTerm = "") =>
    `/api/client/emp-access/list?pageNo=${pageNo}&pageSize=${pageSize}&search=${encodeURIComponent(
      searchTerm,
    )}`,

  DELETE_CLIENT_EMP_ACCESS_LIST: (id) => `/api/client/emp-access/delete/${id}`,

  EDIT_CLIENT_EMP_ACCESS_LIST: (id) => `api/client/emp-access/edit/${id}`,
  EDIT_CLIENT_EMP_ACCESS_LIST_BY_ID: (id) =>
    `/api/client/emp-access/details/${id}`,

  ALL_LOCATIONUSERS: (pageNo, pageSize, searchTerm = "") =>
    `/api/client/location-user/list?pageNo=${pageNo}&pageSize=${pageSize}&search=${encodeURIComponent(
      searchTerm,
    )}`,

  ALL_ROLES: (pageNo, pageSize, searchTerm = "") =>
    `/api/client/emp-access/list?pageNo=${pageNo}&pageSize=${pageSize}&search=${encodeURIComponent(
      searchTerm,
    )}`, ///api/client/emp-access/list?pageNo=1&pageSize=10
  CREATE_LOCATIONUSER: "/api/client/location-user/create",
  EDIT_LOCATIONUSER: (id) => `/api/client/location-user/edit/${id}`,
  DELETE_LOCATION: (id) => `/api/client/location-user/delete/${id}`,
  EDIT_ROLES: (id) => `/api/client/emp-access/edit/${id}`,
  DELETE_ROLE: (id) => `/api/client/emp-access/delete/${id}`,
  LICENSEACCESS: (id) => `/api/client/auth/get/${id}`,
  GET_PROJECT_LICENSES: "/api/client/auth/projects/licenses",
  ROLE_BY_ID: (id) => `/api/client/emp-access/details/${id}`,
  GET_PROJECTS_BY_USER_ID: (id, limit = 10, skip = 0, sort = "-createdAt") =>
    `/api/client/project/user-detail?limit=${limit}&skip=${skip}&sort=${sort}&user_id=${id}`,

  GET_SUB_ADMINS: "/api/client/sub-admin",
  CREATE_SUB_ADMIN: "/api/client/sub-admin/create",
  UPDATE_SUB_ADMIN: (id) => "/api/client/sub-admin/" + id,
  DELETE_SUB_ADMIN: (id) => "/api/client/sub-admin/" + id,

  GET_MANAGEMENT_VIEWS: "/api/client/management-view",
  CREATE_MANAGEMENT_VIEW: "/api/client/management-view/create",
  DELETE_MANAGEMENT_VIEW: (id) => "/api/client/management-view/" + id,

  CREATE_ROLE: "/api/client/emp-access/create",
  GET_ALL_CUSTOMFORMS: `/api/client/custom-form/getAll`,
  RESET_PASSWORD: (id) => `/api/emp/emp-user/reset-password/${id}`,
  // GET_EMPLOYEE_STANDARD_FORM_SECTION: (projectId, templateId, userId, id) =>
  //   `/api/emp/form/getsection-standardForm?projectId=${projectId}&templateId=${templateId}&userId=${userId}&id=${id}`,
  GET_EMPLOYEE_STANDARD_FORM_SECTION: (projectId, templateId, userId, id) =>
    `/api/emp/questions/assigned/sections?projectId=${projectId}&templateId=${templateId}&employeeId=${userId}&userSubDocId=${id}`,
  GET_HIERARCHY_SECTION: (formAllotmentId) =>
    `/api/emp/hierarchy/allotted-sections/${formAllotmentId}`,
  GET_HIERARCHY_SUB_SECTION: (id, sectionId) =>
    `/api/emp/hierarchy/get-standard-subsections?formId=${id}&sectionId=${sectionId}`,
  GET_HIERARCHY_QUESTIONS: (subSectionId) =>
    `/api/emp/hierarchy/questions-by-subsection/${subSectionId}`,
  GET_QUESTION_OPTIONS: (questionId) =>
    `/api/emp/questions/options/${questionId}`,
  GET_CUSTOMER_FORM_QUESTION_OPTIONS: (questionId) =>
    `/api/client/questions/options/${questionId}`,

  GET_CLIENT_ASSIGNED_SECTIONS: (
    projectId,
    templateId,
    employeeId,
    userSubDocId,
  ) =>
    `/api/client/questions/assigned/sections?projectId=${projectId}&templateId=${templateId}&employeeId=${employeeId}&userSubDocId=${userSubDocId}`,
  GET_CLIENT_ASSIGNED_SUBSECTIONS: (
    projectId,
    templateId,
    employeeId,
    userSubDocId,
    sectionId,
  ) =>
    `/api/client/questions/assigned/subsections?projectId=${projectId}&templateId=${templateId}&employeeId=${employeeId}&userSubDocId=${userSubDocId}&sectionId=${sectionId}`,

  GET_TABLE_ROW_TYPE_DEFINITION: (questionId) =>
    `/api/emp/questions/table-row-type/${questionId}`,
  GET_CUSTOMER_TABLE_ROW_TYPE_DEFINITION: (questionId) =>
    `/api/client/questions/table-row-type/${questionId}`,
  SAVE_ANSWERS: `/api/emp/form/save-answer`,
  GET_EMPLOYEE_DYNAMIC_FORM_SECTION: (templateId, userId, id) =>
    `api/emp/form/getsection-dynamicForm?templateId=${templateId}&userId=${userId}&id=${id}`,
  GET_GET_STANDARD_FORM_Section: (formId) =>
    `/api/client/standard-form/sections/${formId}`, // API to get standard form by ID
  SAVE_STANDARD_ANSWERS: "/api/client/standard-form/save-answer",

  // GET_EMPLOYEE_STANDARD_FORM_SUBSECTION: (sectionName) =>
  //   `/api/emp/questions/subsection/${sectionName}`,
  GET_EMPLOYEE_STANDARD_FORM_SUBSECTION: (
    projectId,
    templateId,
    userId,
    id,
    sectionId,
  ) =>
    `/api/emp/questions/assigned/subsections?projectId=${projectId}&templateId=${templateId}&employeeId=${userId}&userSubDocId=${id}&sectionId=${sectionId}`,
  GET_EMPLOYEE_DYNAMIC_FORM_SUBSECTION: (formId, sectionId) =>
    `/api/emp/custom-form/subsections?formId=${formId}&sectionId=${sectionId}`,
  GET_GET_STANDARD_FORM_Subsection: (formId, sectionId) =>
    `/api/client/standard-form/subsections?formId=${formId}&sectionId=${sectionId}`,

  GET_EMPLOYEE_QUESTIONS_FROM_DYNAMIC_SUBSECTION: (
    formId,
    sectionId,
    subsectionId,
  ) =>
    `/api/emp/custom-form/questions?formId=${formId}&sectionId=${sectionId}&subsectionId=${subsectionId}`,
  GET_EMPLOYEE_QUESTIONS_FROM_SUBSECTION: (
    subSection,
    projectId,
    templateId,
    userId,
    id,
  ) =>
    `/api/emp/questions/getBySubsection/${subSection}?projectId=${projectId}&templateId=${templateId}&employeeId=${userId}&userSubDocId=${id}`,
  GET_EMPLOYEE_STANDARD_QUESTIONS_FROM_SUBSECTION: (
    section,
    formId,
    subsectionId,
  ) =>
    `/api/emp/hierarchy/get-standard-questions?formId=${formId}&sectionId=${section}&subsectionId=${subsectionId}`,
  GET_GET_STANDARD_FORM_Questions: (formId, sectionId, subsectionId) =>
    `/api/client/standard-form/questions?formId=${formId}&sectionId=${sectionId}&subsectionId=${subsectionId}`,
  GET_CLIENT_FORM_ANSWER: (allotmentId, sectionId, subsectionId, employeeId) =>
    `/api/client/form/get-answer?standardFormAllotmentId=${allotmentId}&sectionID=${sectionId}&subSectionID=${subsectionId}&user_id=${employeeId}`,
  GET_QUESTION_BY_SUBSECTION_IN_CLIENT: (subsectionId) =>
    `/api/client/questions/getBySubsection/${subsectionId}`,
  GET_STATIC_PAGES: (type) => `/api/static/${type}`,

  // GET_STANDARDFORM_ASSIGNED_USER: (
  //   projectId,
  //   templateId,
  //   clientId,
  //   pageSize,
  //   page,
  //   createdAt,
  // ) =>
  //   `/api/client/project/getUser-standardFormAllotment?limit=${pageSize}&skip=${
  //     (page - 1) * pageSize
  //   }&sort=${createdAt}&client_id=${clientId}&projectId=${projectId}&templateId=${templateId}`,

  GET_STANDARDFORM_ASSIGNED_USER: (
    projectId,
    templateId,
    clientId,
    pageSize,
    pageNo,
    createdAt,
    searchTerm = "",
    skip = 0,
    role = "",
  ) => {
    let url = `/api/client/project/getUser-standardFormAllotment?skip=${skip}&sort=${createdAt}&client_id=${clientId}&projectId=${projectId}&templateId=${templateId}&search=${searchTerm}&pageNo=${pageNo}&pageSize=${pageSize}`;
    if (role) {
      url += `&role=${role}`;
    }
    return url;
  },

  GET_STANDARDFORM_ASSIGNED_USER_ASSIGNED: (
    projectId,
    templateId,
    clientId,
    pageSize,
    pageNo,
    createdAt,
    searchTerm = "",
    skip = 0,
    role = "",
  ) => {
    let url = `/api/client/project/getUser-standardFormAllotment-assigned?skip=${skip}&sort=${createdAt}&client_id=${clientId}&projectId=${projectId}&templateId=${templateId}&search=${searchTerm}&pageNo=${pageNo}&pageSize=${pageSize}`;
    if (role) {
      url += `&role=${role}`;
    }
    return url;
  },

  GET_CUSTOMFORM_ASSINGED_USER: (
    templateId,
    clientId,
    pageSize,
    page,
    createdAt,
  ) =>
    `/api/client/project/getUser-customFormAllotment?limit=${pageSize}&skip=${
      (page - 1) * pageSize
    }&sort=${createdAt}&client_id=${clientId}&templateId=${templateId}`,
  GET_QUESTION_ANSWERS: (standardFormAllotmentId) =>
    `/api/emp/form/get-answer?standardFormAllotmentId=${standardFormAllotmentId}`,
  //LOCATION
  GET_LOCATIONS_OF_CLIENT: "/api/client/location",
  CREATE_LOCATION: "/api/client/location",
  UPDATE_LOCATION: (id) => `/api/client/location/${id}`,
  DELETE_LOCATION: (id) => `/api/client/location/${id}`,
  UPLOAD_CSV: "/api/client/location/csv/parse",
  VALIDATE_MAPPING: "/api/client/location/csv/validate-mapping",
  BULK_LOCATION_IMPORT: "/api/client/location/csv/import-with-mapping",
  //DEPARTMENT
  CREATE_DEPARTMENT: "/api/client/department",
  GET_DEPARTMENT: "/api/client/department",
  UPDATE_DEPARTMENT: (id) => `/api/client/department/${id}`,
  DELETE_DEPARTMENT: (id) => `/api/client/department/${id}`,
  UPLOAD_DEPARTMENT_CSV: "/api/client/department/csv/parse",
  VALIDATE_DEPARTMENT: "/api/client/department/csv/validate-mapping",
  BULK_DEPARTMENT_IMPORT: "/api/client/department/csv/import-with-mapping",
  //GET DEPARTMENT UNDER CLIENT
  GET_DEPARTMENTS: (id) => `/api/client/org-mapping/linked/${id}`,
  GET_LINKED: (id) => `/api/client/org-mapping/linked/${id}`,
  GET_UNLINKED: "/api/client/org-mapping/unlinked",
  CREATE_MAPPING: "/api/client/org-mapping/link",

  // --- VIEW STANDARD FORM (DEMO URLS) ---
  GET_FORM_ASSIGNMENTS: (formId) =>
    `/api/client/form-assignment/list/${formId}`,
  // GET_CLIENT_FORM_ALLOTMENT_HIERARCHY: (formId) =>
  //   `/api/client/form-allotment-hierarchy/${formId}/employees`,

  // apiUrls.js mein ye hona chahiye
  GET_CLIENT_FORM_ALLOTMENT_HIERARCHY: (
    formId,
    skip = 0,
    limit = 10,
    projectId = "",
  ) =>
    `/api/client/form-allotment-hierarchy/${formId}/employees?${projectId ? `projectId=${projectId}&` : ""}skip=${skip}&limit=${limit}`,

  GET_EMP_FORM_ALLOTMENT_HIERARCHY: (
    formId,
    skip = 0,
    limit = 10,
    projectId = "",
  ) =>
    `/api/emp/hierarchy/${formId}/my-form-employees?${projectId ? `projectId=${projectId}&` : ""}skip=${skip}&limit=${limit}`,

  GET_FORM_DETAILS: (formId) => `/api/client/form/details/${formId}`,
  AUTHORIZE_FORM_MANAGE: "/api/client/form-template/authorize",
  AUTHORIZE_FORM_MANAGE_LS2: "/api/client/form-template/authorize-ls2",
  AUTHORIZE_HIERARCHY: "/api/client/form-allotment-hierarchy/allot",
  AUTHORIZE_HIERARCHY_LS2: "/api/emp/hierarchy/allot-form",
  GET_ALLOTTED_SECTIONS: (formAllotmentId) =>
    `/api/emp/hierarchy/allotted-sections/${formAllotmentId}`,

  // --- EMPLOYEE MANAGED FORMS ---
  GET_MANAGED_FORMS: "/api/emp/hierarchy/managed-forms",
  GET_DEPARTMENTS_BY_LOCATION: (locationId) =>
    `/api/emp/hierarchy/departments-by-location/${locationId}`,
  GET_LOCATIONS_BY_DEPARTMENT: (departmentId) =>
    `/api/emp/hierarchy/locations-by-department/${departmentId}`,
  // GET_EMPLOYEES_BY_SCOPE: (locationId, departmentId) =>
  //   `/api/emp/hierarchy/employees-by-scope?locationId=${locationId || ""}&departmentId=${departmentId || ""}`,

  //Customer Import
  CUSTOMER_CSV_UPLOAD: "/api/client/project/csv/parse",
  VALIDATE_CUSTOMER_CSV: "/api/client/project/csv/validate-mapping",
  UPLOAD_CUSTOMER_CSV: "/api/client/project/csv/import-with-mapping",

  GET_EMPLOYEES_BY_SCOPE: ({
    locationId,
    departmentId,
    role = "",
    projectId,
    formId,
    isUnassigned = true,
  }) => {
    let url = `/api/emp/hierarchy/employees-by-scope?locationId=${locationId || ""}&departmentId=${departmentId || ""}&projectId=${projectId || ""}&formId=${formId || ""}&isUnassigned=${isUnassigned}`;
    if (role) {
      url += `&role=${role}`;
    }
    return url;
  },

  GET_FORM_FLOW_TREE: (formId) =>
    `/api/client/form-allotment-hierarchy/${formId}/flow-tree`,
  CHECK_EMPLOYEE_ASSIGNMENTS: "/api/client/employee/check-assignments",
  GET_SDG_DASHBOARD: (type) => `/api/client/dashboard/${type}`,
  GET_GROUP_MEMBERS: "/api/client/dashboard/group/members",
  GET_GROUP_MEMBER_DASHBOARD: (dashboardId, memberId) =>
    `/api/client/dashboard/group/${dashboardId}/member/${memberId}`,
  GET_FORM_HIERARCHY_PROGRESS: (formId, projectId) =>
    `/api/client/form-allotment-hierarchy/${formId}/progress?${projectId ? `projectId=${projectId}` : ""}`,
  GET_LS_ONE: (formId, projectId) =>
    `/api/client/form-allotment-hierarchy/${formId}/ls1s?${projectId ? `projectId=${projectId}` : ""}`,
  GET_LS_TWO: (formId, projectId) =>
    `/api/emp/hierarchy/${formId}/ls2s?${projectId ? `projectId=${projectId}` : ""}`,
  // Notifications API
  NOTIFICATIONS: (prefix) => `/api/${prefix}/notifications`,
  NOTIFICATIONS_UNREAD_COUNT: (prefix) =>
    `/api/${prefix}/notifications/unread-count`,
  NOTIFICATIONS_READ_ALL: (prefix) => `/api/${prefix}/notifications/read-all`,
  NOTIFICATION_READ: (prefix, id) => `/api/${prefix}/notifications/${id}/read`,
  NOTIFICATION_DELETE: (prefix, id) => `/api/${prefix}/notifications/${id}/`,
  SUBSCRIBE_NEWSLETTER: "/api/client/subscriber/subscribe",
};
